<template>
  <!-- Tabs -->
  <v-tabs
    v-model="currentTab"
    align-with-title
    class="tabs-menu"
    hide-slider
    v-if="courseDetail.id"
  >
    <v-tabs-slider color="primary"></v-tabs-slider>
    <v-tab v-for="(tab, idx) in tabsComponent" :key="idx">
      <router-link
        :to="{ name: tab.routerName }"
        :class="tab.color ? tab.color : ''"
        >{{ tab.title }}</router-link
      >
    </v-tab>
    <v-tabs-items v-model="currentTab" style="background: transparent" touchless>
      <v-tab-item
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <CoursesHome :isCourseAdmin="isCourseAdmin" />
      </v-tab-item>
      <v-tab-item
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <CoursesAbout :isCourseAdmin="isCourseAdmin" />
      </v-tab-item>
      <v-tab-item
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <CoursesInterview :isCourseAdmin="isCourseAdmin" />
      </v-tab-item>
      <v-tab-item
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <CoursesReview :isCourseAdmin="isCourseAdmin" />
      </v-tab-item>
      <v-tab-item
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <CoursesVlog :isCourseAdmin="isCourseAdmin" />
      </v-tab-item>
      <v-tab-item
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <CoursesMedia :isCourseAdmin="isCourseAdmin" />
      </v-tab-item>
      <v-tab-item
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>

<script>
import CoursesHome from "@/components/Courses/CoursesHome";
import CoursesAbout from "@/components/Courses/CoursesAbout";
import CoursesInterview from "@/components/Courses/CoursesInterview";
import CoursesVlog from "@/components/Courses/CoursesVlog";
import CoursesMedia from "@/components/Courses/CoursesMedia";
import CoursesReview from "@/components/Courses/CoursesReview";
export default {
  components: {
    CoursesHome,
    CoursesAbout,
    CoursesInterview,
    CoursesVlog,
    CoursesMedia,
    CoursesReview,
  },

  props: [],
  data() {
    return {
      currentTab: 0
    };
  },
  computed: {
    tabsComponent() {
      return [
        {
          title: this.$gettext("Timeline"),
          routerName: "courses.home",
        },
        {
          title: this.$gettext("About"),
          routerName: "courses.about",
        },
        {
          title: this.$gettext("Directors’ Interview"),
          routerName: "courses.directorInterview",
        },
        {
          title: this.$gettext("Reviews"),
          routerName: "courses.reviews",
        },
        {
          title: this.$gettext("Golf VLOG"),
          routerName: "courses.vlog",
        },
        {
          title: this.$gettext("Photos & Videos"),
          routerName: "courses.videosPhotos",
        },
      ]
    },
    courseDetail() {
      return this.$store.state.golfcourse.courseDetail;
    },
    isCourseAdmin() {
      let course = this.courseDetail || {};
      let courseRole = course.courseRole || [];
      if (courseRole.length) {
        return courseRole.some(role => role === "Course Admin");
      }
      return false;
    },
  },
  async created() {
    //set tab
    this.currentTab = this.$route.meta.tab;

    //get/set course detail
    let nameCourse = this.$route.params.namegolf;
    await this.$store.dispatch("getDetailCourse", nameCourse);
    this.$store.state.toggle.isCourseFetch = true;
  },
};
</script>